import Vue from "vue";
import Vuex from "vuex";

import { app, user } from "./stores";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user
  }
});

export default store;
